/**
 * FileAttachedIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const FileAttachedIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8.142 17.45h7.703v-1.584H8.142zm0-4.067h7.703v-1.584H8.142zm-2.247 8.445q-.777 0-1.336-.56A1.82 1.82 0 0 1 4 19.934V3.909q0-.784.559-1.346A1.82 1.82 0 0 1 5.895 2h8.663L20 7.442v12.49q0 .778-.563 1.337a1.84 1.84 0 0 1-1.346.559zm7.675-13.47v-4.45H5.895v16.025h12.196V8.358z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const FileAttachedIcon = makeIcon('FileAttachedIcon', FileAttachedIconSvg)
